  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
//import Radio                                               from '@material-ui/core/Radio';
//import RadioGroup                                          from '@material-ui/core/RadioGroup';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import Typography                                          from '@material-ui/core/Typography';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
  import InputLabel                                          from '@material-ui/core/InputLabel';
  import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Select                                              from '@material-ui/core/Select';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  import { createFilterOptions }                             from '@material-ui/lab/Autocomplete';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //[POPOVER]
//import Popover                                             from '@material-ui/core/Popover';
//import IconButton                                          from '@material-ui/core/IconButton';
//import InputAdornment                                      from '@material-ui/core/InputAdornment';
//import Typography                                          from '@material-ui/core/Typography';
//import InfoIcon                                            from '@material-ui/icons/Info';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
//import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
//import moment                                              from "moment";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
//import { wu_GeolocationService }                           from "../../_services";
  //------
  // Style
  //------
  import SettingsProfilePersonalStyle                        from "./SettingsProfilePersonalStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
//import img2                                                from "assets/img/wu/testImg2.png";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //[Campaign]
  import WU_popup_campaign_el                                from "assets/img/wu/popup_campaign_el.png";
  import WU_popup_campaign_en                                from "assets/img/wu/popup_campaign_en.png";
  //----------
  // variables
  //----------
  const filename = "SettingsProfilePersonal ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  let birthDate_dv = "2000-01-01";

  //[flagsimages]
  var images = null;

  //[Lockers]
  var SettingsProfilePersonal_continue_locked = true;

class SettingsProfilePersonal extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    let firstName     = "";
    let lastName      = "";
    let email         = "";
    let birthCity     = "";
    let birthDate     = birthDate_dv;
    let cityResidence = "";
    let homeAddress   = "";
    let postalCode    = "";

    let parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}

    let aTextDecision = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //[HONEYMOON]
      textField0                                           : "", //4279034659
      textField0_hasError                                  : false,

      lbl_info1_text                                       : "",
      lbl_info1_isHidden                                   : false,

      firstName                                            : firstName,   //TextField
      firstName_disabled                                   : false,
      firstName_hasError                                   : false,
      firstName_isHidden                                   : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
      lastName                                             : lastName,    //TextField
      lastName_disabled                                    : false,
      lastName_hasError                                    : false,
      lastName_isHidden                                    : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
      email                                                : email,       //TextField
      email_disabled                                       : false,
      email_hasError                                       : false,
      email_isHidden                                       : false,
      preferredLanguage_text                               : "",          //DropDown---language
      preferredLanguage_id                                 : "",
      preferredLanguage_hasError                           : false,
      preferredLanguage_isHidden                           : false,
      birthCountryId_text                                  : "",          //DropDown
      birthCountryId_id                                    : "",
      birthCountryId_disabled                              : false,
      birthCountryId_hasError                              : false,
      birthCountryId_isHidden                              : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
      birthCountryId_AUTOCOMPLETE_MODE                     : "object", //"text","object";
      birthCountryId_AUTOCOMPLETE_FILTER_OPTIONS           : "any",    //"start","any"
      state_code_text                                      : "",          //DropDown
      state_code_id                                        : "",
      birthCity                                            : birthCity,   //TextField
      birthCity_disabled                                   : false,
      birthCity_hasError                                   : false,
      birthCity_isHidden                                   : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
      birthDate                                            : birthDate,   //DatePicker
      birthDate_disabled                                   : false,
      birthDate_hasError                                   : false,
      birthDate_isHidden                                   : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,

      countryResidence_id                                  : "",               //DropDown
      countryResidence_text                                : "",
      countryResidence_hasError                            : false,
      countryResidence_isHidden                            : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
      countryResidence_AUTOCOMPLETE_MODE                   : "object", //"text","object";
      countryResidence_AUTOCOMPLETE_FILTER_OPTIONS         : "any",    //"start","any"
      cityResidence                                        : cityResidence,    //TextField
      cityResidence_hasError                               : false,
      cityResidence_isHidden                               : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
      homeAddress                                          : homeAddress,      //TextField
      homeAddress_hasError                                 : false,
      homeAddress_isHidden                                 : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
      postalCode                                           : postalCode,       //TextField
      postalCode_hasError                                  : false,
      postalCode_isHidden                                  : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,

      profession_id                                        : "",               //DropDown
      profession_text                                      : "",
      profession_hasError                                  : false,
      profession_isHidden                                  : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
      positionLevel_id                                     : "",               //DropDown
      positionLevel_text                                   : "",
      positionLevel_hasError                               : false,
      positionLevel_isHidden                               : true,

      parserObject_getCountries                            : [],
      parserObject_getCountries4Picker                     : [],
      parserObject_getLanguages                            : [],
      parserObject_getPhonePrefixes                        : [],
      parserObject_getPhonePrefixes4Picker                 : [],

      parserObject_getDays                                 : [],
      parserObject_getMonths                               : [],
      parserObject_getYears                                : [],

      birthDateDay_text                                    : "",          //DropDown
    //birthDateDay_id                                      : "",
      birthDateDay_disabled                                : false,
      birthDateDay_hasError                                : false,
      birthDateMonth_text                                  : "",          //DropDown
    //birthDateMonth_id                                    : "",
      birthDateMonth_disabled                              : false,
      birthDateMonth_hasError                              : false,
      birthDateYear_text                                   : "",          //DropDown
    //birthDateYear_id                                     : "",
      birthDateYear_disabled                               : false,
      birthDateYear_hasError                               : false,

      btn_next_text                                        : "",

      //[Campaign]
      dialog101_msg                                        : "",
      dialog101_isOpen                                     : false,
      dialog101_campaign_image_w                           : "512",
      dialog101_campaign_image_h                           : "268",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                 = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                = this.dialog_handleClose.bind(this);
    this.startSpinners                                     = this.startSpinners.bind(this);
    this.stopSpinners                                      = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                              = this.isLockersActive.bind(this);
    this.startLockers                                                 = this.startLockers.bind(this);
    this.stopLockers                                                  = this.stopLockers.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                              = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                             = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                            = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                     = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                    = this.Snackbar_textField_handleClose.bind(this);

    this.btn_next_act                                      = this.btn_next_act.bind(this);
    this.btn_next_act_isDisabled                           = this.btn_next_act_isDisabled.bind(this);
    this.btn_next_act_FULL                                 = this.btn_next_act_FULL.bind(this);
    this.btn_next_act_LIGHT                                = this.btn_next_act_LIGHT.bind(this);
    this.btn_next_act_BP                                   = this.btn_next_act_BP.bind(this);

    this.handleSubmit_with_recaptcha                       = this.handleSubmit_with_recaptcha.bind(this);
    this.recaptchaRef                                      = React.createRef();

    this.handleCustomDropDownClick_languages               = this.handleCustomDropDownClick_languages.bind(this);
    this.handleCustomDropDownClick_birthCountryId          = this.handleCustomDropDownClick_birthCountryId.bind(this);

    this.handleCustomDropDownClick_birthDateDay           = this.handleCustomDropDownClick_birthDateDay.bind(this);
    this.handleCustomDropDownClick_birthDateMonth         = this.handleCustomDropDownClick_birthDateMonth.bind(this);
    this.handleCustomDropDownClick_birthDateYear          = this.handleCustomDropDownClick_birthDateYear.bind(this);
    this.checkBirthDate                                   = this.checkBirthDate.bind(this);

    this.handleCustomDropDownClick_countryResidence        = this.handleCustomDropDownClick_countryResidence.bind(this);

    this.handleCustomDropDownClick_profession              = this.handleCustomDropDownClick_profession.bind(this);
    this.handleCustomDropDownClick_positionLevel           = this.handleCustomDropDownClick_positionLevel.bind(this);

    //[CAMPAIGN]
    this.dialog101_handleOpen                                         = this.dialog101_handleOpen.bind(this);
    this.dialog101_handleClose                                        = this.dialog101_handleClose.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    if(api.print_logs){console.log(methName+localStorage.getItem("curr_view")+",history.length="+history.length);}

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }

    //Do nothing if---get
    if(localStorage.getItem("prev_view").trim()==="RegisterLight2"){
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){;}
      return;
    }

    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}

    let currYear = parseInt((new Date()).getFullYear());
    let parserObject_getDays_TMP   = [];
    let parserObject_getMonths_TMP = [];
    let parserObject_getYears_TMP  = [];
    for(let i=1;            i<32;            ++i){parserObject_getDays_TMP.push(i.toString());}
    for(let i=1;            i<13;            ++i){parserObject_getMonths_TMP.push(i.toString());}
    for(let i=currYear-100; i<currYear-18+1; ++i){parserObject_getYears_TMP.push(i.toString());}
    this.setState({
      "parserObject_getDays"   : parserObject_getDays_TMP,
      "parserObject_getMonths" : parserObject_getMonths_TMP,
      "parserObject_getYears"  : parserObject_getYears_TMP,
    });

    //[flagsimages]
    images = this.importAll(require.context('assets/img/flagspng/', false, /\.(png|svg)$/));
    //if(api.print_logs){console.log("images.length="+images.length);}
    //for (var key in images) { if(api.print_logs){console.log("key="+key);} }

    //this.startSpinners();
    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="SettingsProfilePersonal"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        var parserObject_getCountries4Picker = [];
        //res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        //res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        //res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      }catch(err){
        console.log('err='+err);
      }
    }
    //---------------
    //wu_getLanguages
    //---------------
    var res_obj_getLanguages = wu_StaticDataService.wu_getLanguages({});
    var parserObject_getLanguages4Picker_el = [];
    var parserObject_getLanguages4Picker_en = [];
    let descr_getLanguages_el = "descr_el";
    let descr_getLanguages_en = "descr_en";
    for(let i=0; i<res_obj_getLanguages.languages.length; ++i){ parserObject_getLanguages4Picker_el.push(res_obj_getLanguages.languages[i][descr_getLanguages_el]); }
    for(let i=0; i<res_obj_getLanguages.languages.length; ++i){ parserObject_getLanguages4Picker_en.push(res_obj_getLanguages.languages[i][descr_getLanguages_en]); }
    this.setState({ "parserObject_getLanguages_el"        : res_obj_getLanguages.languages });
    this.setState({ "parserObject_getLanguages_en"        : res_obj_getLanguages.languages });
    this.setState({ "parserObject_getLanguages4Picker_el" : parserObject_getLanguages4Picker_el });
    this.setState({ "parserObject_getLanguages4Picker_en" : parserObject_getLanguages4Picker_en });
    this.setState({ "preferredLanguage_text"              : "" });
    this.setState({ "preferredLanguage_id"                : "" });
    //-----------------
    //wu_getProfessions---STATIC
    //-----------------
    let res_obj_getProfessions = wu_StaticDataService.wu_getProfessions({});
    let parserObject_getProfessions4Picker_el = [];
    let parserObject_getProfessions4Picker_en = [];
    let descKey_professions_el = "descr_el";
    let descKey_professions_en = "descr_en";
    let professions_sorted_el = JSON.parse(JSON.stringify(res_obj_getProfessions.professions));
    let professions_sorted_en = JSON.parse(JSON.stringify(res_obj_getProfessions.professions));
    professions_sorted_el.sort(function(a, b) {
      if( (a.descr_el).localeCompare(b.descr_el) === -1){ return -1; }
      if( (a.descr_el).localeCompare(b.descr_el) === 1){ return 1; }
      return 0;
    });
    professions_sorted_en.sort(function(a, b) {
      if( (a.descr_en).localeCompare(b.descr_en) === -1){ return -1; }
      if( (a.descr_en).localeCompare(b.descr_en) === 1){ return 1; }
      return 0;
    });
    for(let i=0; i<professions_sorted_el.length; ++i){ parserObject_getProfessions4Picker_el.push(professions_sorted_el[i][descKey_professions_el]); }
    for(let i=0; i<professions_sorted_en.length; ++i){ parserObject_getProfessions4Picker_en.push(professions_sorted_en[i][descKey_professions_en]); }
    this.setState({
      "parserObject_getProfessions_el"        : professions_sorted_el,
      "parserObject_getProfessions_en"        : professions_sorted_en,
      "parserObject_getProfessions4Picker_el" : parserObject_getProfessions4Picker_el,
      "parserObject_getProfessions4Picker_en" : parserObject_getProfessions4Picker_en,
      "profession_id"                         : "",
      "profession_text"                       : "",
      "profession_hasError"                   : false,
    });
    //if(api.print_logs){console.log("parserObject_getProfessions4Picker_el="+parserObject_getProfessions4Picker_el);}
    //if(api.print_logs){console.log("parserObject_getProfessions4Picker_en="+parserObject_getProfessions4Picker_en);}
    //-------------------
    //wu_getPositionLevel---STATIC
    //-------------------
    var res_obj_getPositionLevel = wu_StaticDataService.wu_getPositionLevel({});
    var parserObject_getPositionLevel4Picker_el = [];
    var parserObject_getPositionLevel4Picker_en = [];
    let descKey_positionLevel_el = "descr_el";
    let descKey_positionLevel_en = "descr_en";
    for(let i=0; i<res_obj_getPositionLevel.positions.length; ++i){ parserObject_getPositionLevel4Picker_el.push(res_obj_getPositionLevel.positions[i][descKey_positionLevel_el]); }
    for(let i=0; i<res_obj_getPositionLevel.positions.length; ++i){ parserObject_getPositionLevel4Picker_en.push(res_obj_getPositionLevel.positions[i][descKey_positionLevel_en]); }
    this.setState({
      "parserObject_getPositionLevel"           : res_obj_getPositionLevel.positions,
      "parserObject_getPositionLevel4Picker_el" : parserObject_getPositionLevel4Picker_el,
      "parserObject_getPositionLevel4Picker_en" : parserObject_getPositionLevel4Picker_en,
      "positionLevel_id"                        : "",
      "positionLevel_text"                      : "",
      "positionLevel_hasError"                  : false,
    });

    //-------------------
    //wu_validatecustomer
    //-------------------
    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    wu_ProfileService
    .wu_validatecustomer({})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="SettingsProfilePersonal"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

      let ws_firstName         = "";
      let ws_lastName          = "";
      let ws_email             = "";
      let ws_preferredLanguage = "";
      let ws_ctry_iso_id       = "";
      let ws_birthCity         = "";
      let ws_birthDate         = "";
      try {ws_firstName         = res.customer["fname"];             }catch(err){;} if(ws_firstName         === null || (typeof ws_firstName         ==="undefined")){ws_firstName         = "";}
      try {ws_lastName          = res.customer["lname"];             }catch(err){;} if(ws_lastName          === null || (typeof ws_lastName          ==="undefined")){ws_lastName          = "";}
      try {ws_email             = res.customer["email"];             }catch(err){;} if(ws_email             === null || (typeof ws_email             ==="undefined")){ws_email             = "";}
      try {ws_preferredLanguage = res.customer["preferredLanguage"]; }catch(err){;} if(ws_preferredLanguage === null || (typeof ws_preferredLanguage ==="undefined")){ws_preferredLanguage = "";}
      try {ws_ctry_iso_id       = res.customer["ctry_iso_id"];       }catch(err){;} if(ws_ctry_iso_id       === null || (typeof ws_ctry_iso_id       ==="undefined")){ws_ctry_iso_id       = "";}
      try {ws_birthCity         = res.customer["birthCity"];         }catch(err){;} if(ws_birthCity         === null || (typeof ws_birthCity         ==="undefined")){ws_birthCity         = "";}
    //try {ws_birthDate         = res.customer["birth_date"];        }catch(err){;} if(ws_birthDate         === null || (typeof ws_birthDate         ==="undefined")){ws_birthDate         = birthDate_dv;}
      try {ws_birthDate         = res.customer["birth_date"];        }catch(err){;} if(ws_birthDate         === null || (typeof ws_birthDate         ==="undefined")){ws_birthDate         = "";}

      let ws_countryResidence = "";
      let ws_city             = "";
      let ws_address          = "";
      let ws_post_code        = "";
      let ws_phone            = "";
      let ws_isMobile         = 0;
      try {ws_countryResidence = res.customer["countryResidence"]; }catch(err){;} if(ws_countryResidence === null || (typeof ws_countryResidence ==="undefined")){ws_countryResidence = "";}
      try {ws_city             = res.customer["city"];             }catch(err){;} if(ws_city             === null || (typeof ws_city             ==="undefined")){ws_city             = "";}
      try {ws_address          = res.customer["address"];          }catch(err){;} if(ws_address          === null || (typeof ws_address          ==="undefined")){ws_address          = "";}
      try {ws_post_code        = res.customer["post_code"];        }catch(err){;} if(ws_post_code        === null || (typeof ws_post_code        ==="undefined")){ws_post_code        = "";}
      try {ws_phone            = res.customer["phone"];            }catch(err){;} if(ws_phone            === null || (typeof ws_phone            ==="undefined")){ws_phone            = "";}
      try {ws_isMobile         = res.customer["isMobile"];         }catch(err){;} if(ws_isMobile         === null || (typeof ws_isMobile         ==="undefined")){ws_isMobile         = 0; }
      let ws_profession       = "";
      let ws_positionLevelId  = 0;
      try {ws_profession       = res.customer["profession"];       }catch(err){;} if(ws_profession       === null || (typeof ws_profession       ==="undefined")){ws_profession       = "";}
      try {ws_positionLevelId  = res.customer["positionLevelId"];  }catch(err){;} if(ws_positionLevelId  === null || (typeof ws_positionLevelId  ==="undefined")){ws_positionLevelId  = "";}

      if(ws_preferredLanguage==="gr"){ws_preferredLanguage="el";}
      //console.log("XXX="+wu_Utilities.findLanguageNameFromLanguageId(api.print_logs,ws_preferredLanguage,localStorage.getItem("lang")));

      //birth_date: "1980-10-06"
      let ws_birthDateDay   = "";
      let ws_birthDateMonth = "";
      let ws_birthDateYear  = "";
      if(ws_birthDate!==""){
        try {ws_birthDateDay   = ws_birthDate.substring(8, 8+2); }catch(err){;} if(ws_birthDateDay   === null || (typeof ws_birthDateDay   ==="undefined")){ws_birthDateDay   = "";}
        try {ws_birthDateMonth = ws_birthDate.substring(5, 5+2); }catch(err){;} if(ws_birthDateMonth === null || (typeof ws_birthDateMonth ==="undefined")){ws_birthDateMonth = "";}
        try {ws_birthDateYear  = ws_birthDate.substring(0, 0+4); }catch(err){;} if(ws_birthDateYear  === null || (typeof ws_birthDateYear   ==="undefined")){ws_birthDateYear = "";}
      }

      let aTextDecision = wu_Utilities.textDecisions_customerLevel(api.print_logs,res.customer);

      var lbl_info1_text     = "";
      var lbl_info1_isHidden = true;
      if(aTextDecision === "FULL") { lbl_info1_text = this.NSInforString("SettingsProfilePersonal_lbl_info1_FULL");  lbl_info1_isHidden = true; }
      if(aTextDecision === "LIGHT"){ lbl_info1_text = this.NSInforString("SettingsProfilePersonal_lbl_info1_LIGHT"); lbl_info1_isHidden = false; }
      if(aTextDecision === "BP")   { lbl_info1_text = this.NSInforString("SettingsProfilePersonal_lbl_info1_BP");    lbl_info1_isHidden = false; }
      var btn_next_text = "";
      if(aTextDecision === "FULL") { btn_next_text = this.NSInforString("SettingsProfilePersonal_btn_next_FULL");  }
      if(aTextDecision === "LIGHT"){ btn_next_text = this.NSInforString("SettingsProfilePersonal_btn_next_BP");    }
      if(aTextDecision === "BP")   { btn_next_text = this.NSInforString("SettingsProfilePersonal_btn_next_LIGHT"); }

      this.setState({
        lbl_info1_text                                       : lbl_info1_text,
        lbl_info1_isHidden                                   : lbl_info1_isHidden,
        firstName                                            : ws_firstName,
        firstName_disabled                                   : ws_firstName===""   ? false : true,
        firstName_isHidden                                   : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
        lastName                                             : ws_lastName,
        lastName_disabled                                    : ws_lastName===""    ? false : true,
        lastName_isHidden                                    : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
        email                                                : ws_email,
      //email_disabled                                       : ws_email===""       ? false : true,
        email_disabled                                       : false,
        preferredLanguage_text                               : wu_Utilities.findLanguageNameFromLanguageId(api.print_logs,ws_preferredLanguage,localStorage.getItem("lang")),
        preferredLanguage_id                                 : ws_preferredLanguage,
        preferredLanguage_hasError                           : false,
        birthCountryId_text                                  : this.state.birthCountryId_AUTOCOMPLETE_MODE==="text" ? wu_Utilities.findCountryNameFromCountryId(ws_ctry_iso_id,localStorage.getItem("lang")) : wu_Utilities.findCountryObjFromCountryId(ws_ctry_iso_id,localStorage.getItem("lang")),
        birthCountryId_id                                    : ws_ctry_iso_id,
        birthCountryId_disabled                              : ws_ctry_iso_id==="" ? false : true,
        birthCountryId_isHidden                              : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
        birthCity                                            : ws_birthCity,
        birthCity_disabled                                   : ws_birthCity===""   ? false : true,
        birthCity_isHidden                                   : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
        birthDate                                            : ws_birthDate,
        birthDate_disabled                                   : ws_birthDate===""   ? false : true,
        birthDate_isHidden                                   : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,

        birthDateDay_text                                    : ws_birthDateDay,
      //birthDateDay_id                                      : "",
        birthDateDay_disabled                                : ws_birthDate===""   ? false : true,
        birthDateDay_hasError                                : false,
        birthDateMonth_text                                  : ws_birthDateMonth,
      //birthDateMonth_id                                    : "",
        birthDateMonth_disabled                              : ws_birthDate===""   ? false : true,
        birthDateMonth_hasError                              : false,
        birthDateYear_text                                   : ws_birthDateYear,
      //birthDateYear_id                                     : "",
        birthDateYear_disabled                               : ws_birthDate===""   ? false : true,
        birthDateYear_hasError                               : false,

        countryResidence_id                                  : ws_countryResidence,
        countryResidence_text                                : this.state.countryResidence_AUTOCOMPLETE_MODE==="text" ? wu_Utilities.findCountryNameFromCountryId(ws_countryResidence,localStorage.getItem("lang")) : wu_Utilities.findCountryObjFromCountryId(ws_countryResidence,localStorage.getItem("lang")),
        countryResidence_hasError                            : false,
        countryResidence_isHidden                            : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
        cityResidence                                        : ws_city,
        cityResidence_isHidden                               : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
        homeAddress                                          : ws_address,
        homeAddress_isHidden                                 : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
        postalCode                                           : ws_post_code,
        postalCode_isHidden                                  : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,

        profession_id                                        : ws_profession,
        profession_text                                      : wu_Utilities.findProfessionNameFromProfessionId(ws_profession,localStorage.getItem("lang")),
        profession_hasError                                  : false,
        profession_isHidden                                  : (aTextDecision==="BP" || aTextDecision==="LIGHT") ? true : false,
        positionLevel_id                                     : ws_positionLevelId+"",
        positionLevel_text                                   : wu_Utilities.findPositionlevelNameFromPositionlevelId(ws_positionLevelId+"",localStorage.getItem("lang")),
        positionLevel_hasError                               : false,
        positionLevel_isHidden                               : (aTextDecision==="BP" || aTextDecision==="LIGHT") || this.get_positionLevel_isHidden(ws_profession) ? true : false,

        btn_next_text                                        : btn_next_text,
      });
    })
    .catch(err => {
      this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });

    //[CAMPAIGN]
    //wu_Utilities.campaign_clear_statsView(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,filename.trim());
    wu_Utilities.campaign_record_load(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim());
    if(wu_Utilities.campaign_should_show(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim())===true){
      console.log("campaigns window.innerWidth="+window.innerWidth);
      if(window.innerWidth > 960){ this.setState({"dialog101_campaign_image_w":"512","dialog101_campaign_image_h":"268",}); }
      else                       { this.setState({"dialog101_campaign_image_w":"256","dialog101_campaign_image_h":"134",}); }
      this.dialog101_handleOpen("");
    }

    //[Lockers]
    this.stopLockers();
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    //------------
    //CountryBirth
    //------------
    let defaultPropsCountryBirth  = {};
    let filterOptionsCountryBirth = {};
    if(this.state.birthCountryId_AUTOCOMPLETE_MODE === "text"){
      defaultPropsCountryBirth  = { options:this.state.parserObject_getCountries4Picker, getOptionLabel:option => option,};
      filterOptionsCountryBirth = createFilterOptions({matchFrom: this.state.birthCountryId_AUTOCOMPLETE_FILTER_OPTIONS, stringify: option => option, });
    }
    else{
      if(localStorage.getItem("lang")==="en"){ defaultPropsCountryBirth = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_en ? option.descr_en : "", }; }
      else                                   { defaultPropsCountryBirth = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_el ? option.descr_el : "", }; }
      filterOptionsCountryBirth = createFilterOptions({matchFrom: this.state.birthCountryId_AUTOCOMPLETE_FILTER_OPTIONS,stringify: (option) => option.descr_el + option.descr_en + option.keywords,});
    }
    //----------------
    //CountryResidence
    //----------------
    let defaultPropsCountryResidence  = {};
    let filterOptionsCountryResidence = {};
    if(this.state.countryResidence_AUTOCOMPLETE_MODE === "text"){
      defaultPropsCountryResidence  = { options:this.state.parserObject_getCountries4Picker, getOptionLabel:option => option,};
      filterOptionsCountryResidence = createFilterOptions({matchFrom: this.state.countryResidence_AUTOCOMPLETE_FILTER_OPTIONS, stringify: option => option, });
    }
    else{
      if(localStorage.getItem("lang")==="en"){ defaultPropsCountryResidence = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_en ? option.descr_en : "", }; }
      else                                   { defaultPropsCountryResidence = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_el ? option.descr_el : "", }; }
      filterOptionsCountryResidence = createFilterOptions({matchFrom: this.state.countryResidence_AUTOCOMPLETE_FILTER_OPTIONS,stringify: (option) => option.descr_el + option.descr_en + option.keywords,});
    }
    const defaultPropsDay = {
      options        : this.state.parserObject_getDays,
      getOptionLabel : option => option,
    };
    const defaultPropsMonth = {
      options        : this.state.parserObject_getMonths,
      getOptionLabel : option => option,
    };
    const defaultPropsYear = {
      options        : this.state.parserObject_getYears,
      getOptionLabel : option => option,
    };

    var lang = localStorage.getItem("lang");
    var parserObject_getProfessions4Picker   = (lang==="el") ? this.state.parserObject_getProfessions4Picker_el   : this.state.parserObject_getProfessions4Picker_en;
    var parserObject_getPositionLevel4Picker = (lang==="el") ? this.state.parserObject_getPositionLevel4Picker_el : this.state.parserObject_getPositionLevel4Picker_en;
    var parserObject_getLanguages4Picker     = (lang==="el") ? this.state.parserObject_getLanguages4Picker_el     : this.state.parserObject_getLanguages4Picker_en;
    var profession_text                      = this.translate_profession(   lang,this.state.profession_id,         this.state.profession_text);
    var positionLevel_text                   = this.translate_positionLevel(lang,this.state.positionLevel_id,      this.state.positionLevel_text);
    var preferredLanguage_text               = this.translate_language(     lang,this.state.preferredLanguage_id,  this.state.preferredLanguage_text);
    //console.log(methName+"lang                          = "+lang);
    //console.log(methName+"this.state.profession_id      = "+this.state.profession_id);
    //console.log(methName+"this.state.profession_text    = "+this.state.profession_text);
    //console.log(methName+"profession_text               = "+profession_text);
    //console.log(methName+"this.state.positionLevel_id   = "+this.state.positionLevel_id);
    //console.log(methName+"this.state.positionLevel_text = "+this.state.positionLevel_text);
    //console.log(methName+"positionLevel_text            = "+positionLevel_text);

    let parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    let aTextDecision = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);

    var lbl_info1_text     = "";
    var lbl_info1_isHidden = true;
    if(aTextDecision === "FULL") { lbl_info1_text = this.NSInforString("SettingsProfilePersonal_lbl_info1_FULL");  lbl_info1_isHidden = true; }
    if(aTextDecision === "LIGHT"){ lbl_info1_text = this.NSInforString("SettingsProfilePersonal_lbl_info1_LIGHT"); lbl_info1_isHidden = false; }
    if(aTextDecision === "BP")   { lbl_info1_text = this.NSInforString("SettingsProfilePersonal_lbl_info1_BP");    lbl_info1_isHidden = false; }
    if(api.print_logs){console.log(methName+"lbl_info1_isHidden="+lbl_info1_isHidden);}
    var btn_next_text = "";
    if(aTextDecision === "FULL") { btn_next_text = this.NSInforString("SettingsProfilePersonal_btn_next_FULL");  }
    if(aTextDecision === "LIGHT"){ btn_next_text = this.NSInforString("SettingsProfilePersonal_btn_next_BP");    }
    if(aTextDecision === "BP")   { btn_next_text = this.NSInforString("SettingsProfilePersonal_btn_next_LIGHT"); }

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={7} md={7}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("SettingsProfilePersonal_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("SettingsProfilePersonal_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}

            {this.state.lbl_info1_isHidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.label1}>{lbl_info1_text}</div>
                  <div className={classes.labelHeader}>&nbsp;</div>
                </GridItem>
              </GridContainer>
            )}

            <GridContainer justify="center">
              {/* ------------------------- */}
              {/* ----------[HONEYMOON]---- */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                  <TextField
                    fullWidth
                    autoComplete={this.autoCompleteText_Textfields()}
                    error={this.state.textField0_hasError}
                    className={classes.textField0}
                    id={this.autoCompleteText_Textfields()}
                    label={this.autoCompleteText_Textfields()}
                    value={this.state.textField0}
                    InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                  />
              </GridItem>

              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {this.state.firstName_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    error   ={this.state.firstName_hasError}
                    disabled={this.state.firstName_disabled}
                    className={classes.firstName}
                    id="firstName"
                    label={this.NSInforString("SettingsProfilePersonal_plh01")}
                    value={this.state.firstName}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "firstName"),
                      type: "text",
                    }}
                  />
                </GridItem>
              )}
              {this.state.lastName_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    error   ={this.state.lastName_hasError}
                    disabled={this.state.lastName_disabled}
                    className={classes.lastName}
                    id="lastName"
                    label={this.NSInforString("SettingsProfilePersonal_plh02")}
                    value={this.state.lastName}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "lastName"),
                      type: "text"
                    }}
                  />
                </GridItem>
              )}
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={6}>
                <TextField
                  fullWidth
                  error   ={this.state.email_hasError}
                  disabled={this.state.email_disabled}
                  className={classes.email}
                  id="email"
                  label={this.NSInforString("SettingsProfilePersonal_plh03")}
                  value={this.state.email}
                  InputProps={{
                    fullWidth: true,
                    onChange: event => this.change(event, "email"),
                    type: "email"
                  }}
                />
                <div className={classes.label_emailInfo}>{this.NSInforString("SettingsProfilePersonal_emailInfo_lbl_lbl1")}</div>
                {/* <div className={classes.label_emailInfo}>{(localStorage.getItem("isLoggedIn")==="true") ? "" : this.NSInforString("SettingsProfilePersonal_emailInfo_lbl_lbl1")}</div> */}
              </GridItem>
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth error={this.state.preferredLanguage_hasError} className={classes.preferredLanguage}>
                  <InputLabel id="preferredLanguage_InputLabel">{this.NSInforString("SettingsProfilePersonal_plh04")}</InputLabel>
                  <Select
                    displayEmpty
                    id="preferredLanguage"
                    value={preferredLanguage_text+""}
                    onChange={event => this.handleCustomDropDownClick_languages(event)}
                  >
                    {parserObject_getLanguages4Picker.map(function (akey) {
                      return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {this.state.birthCountryId_isHidden === false && this.state.birthCountryId_AUTOCOMPLETE_MODE === "text" ? (
                <GridItem xs={12} sm={12} md={6}>
                  <FormControl fullWidth className={classes.birthCountryId}>
                    <Autocomplete
                      {...defaultPropsCountryBirth}
                      disabled={this.state.birthCountryId_disabled}
                      id="birthCountryId"
                      value={this.state.birthCountryId_text}
                      disableClearable
                      onChange={(event,value) => this.handleCustomDropDownClick_birthCountryId(event,value)}
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                      renderInput={params => <TextField {...params} error={this.state.birthCountryId_hasError} label={this.NSInforString("SettingsProfilePersonal_plh05")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                    />
                  </FormControl>
                </GridItem>
              ) : ("") }
              {this.state.birthCountryId_isHidden === false && this.state.birthCountryId_AUTOCOMPLETE_MODE === "object" ? (
                <GridItem xs={12} sm={12} md={6}>
                  <FormControl fullWidth className={classes.birthCountryId}>
                    <Autocomplete
                      filterOptions={filterOptionsCountryBirth}
                      {...defaultPropsCountryBirth}
                      disabled={this.state.birthCountryId_disabled}
                      id="birthCountryId"
                      value={this.state.birthCountryId_text}
                      disableClearable
                      onChange={(event,value) => this.handleCustomDropDownClick_birthCountryId(event,value)}
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option.descr_en).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option.descr_en}</Typography></React.Fragment>);}}
                      renderInput={params => <TextField {...params} error={this.state.birthCountryId_hasError} label={this.NSInforString("SettingsProfilePersonal_plh05")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                    />
                  </FormControl>
                </GridItem>
              ) : ("") }
              {this.state.birthCity_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    error   ={this.state.birthCity_hasError}
                    disabled={this.state.birthCity_disabled}
                    className={classes.birthCity}
                    id="birthCity"
                    label={this.NSInforString("SettingsProfilePersonal_plh06")}
                    value={this.state.birthCity}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "birthCity"),
                      type: "text"
                    }}
                  />
                </GridItem>
              )}
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {this.state.birthDate_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} style={{ marginBottom:0,marginTop:10 }}>
                        <div className={classes.label1}>{this.NSInforString("SettingsProfilePersonal_plh07")}</div>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2} className={classes.GridItemLocal_d}>
                      <FormControl fullWidth className={classes.birthDateDay}>
                        <Autocomplete
                          {...defaultPropsDay}
                          disabled={this.state.birthDateDay_disabled}
                          id="birthDateDayId"
                          value={this.state.birthDateDay_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateDay(event,value)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateDay_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_d")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2} className={classes.GridItemLocal_m}>
                      <FormControl fullWidth className={classes.birthDateMonth}>
                        <Autocomplete
                          {...defaultPropsMonth}
                          disabled={this.state.birthDateMonth_disabled}
                          id="birthDateMonthId"
                          value={this.state.birthDateMonth_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateMonth(event,value)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateMonth_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_m")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2} className={classes.GridItemLocal_y}>
                      <FormControl fullWidth className={classes.birthDateYear}>
                        <Autocomplete
                          {...defaultPropsYear}
                          disabled={this.state.birthDateYear_disabled}
                          id="birthDateYearId"
                          value={this.state.birthDateYear_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateYear(event,value)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateYear_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_y")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6}>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              )}
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {this.state.countryResidence_isHidden === false && this.state.countryResidence_AUTOCOMPLETE_MODE === "text" ? (
                <GridItem xs={12} sm={12} md={6}>
                  <FormControl fullWidth className={classes.countryResidence}>
                    <Autocomplete
                      {...defaultPropsCountryResidence}
                      id="countryResidence"
                      value={this.state.countryResidence_text}
                      disableClearable
                      onChange={(event,value) => this.handleCustomDropDownClick_countryResidence(event,value)}
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                      renderInput={params => <TextField {...params} error={this.state.countryResidence_hasError} label={this.NSInforString("SettingsProfilePersonal_plh08")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                    />
                  </FormControl>
                </GridItem>
              ) : ("") }
              {this.state.countryResidence_isHidden === false && this.state.countryResidence_AUTOCOMPLETE_MODE === "object" ? (
                <GridItem xs={12} sm={12} md={6}>
                  <FormControl fullWidth className={classes.countryResidence}>
                    <Autocomplete
                      filterOptions={filterOptionsCountryResidence}
                      {...defaultPropsCountryResidence}
                      id="countryResidence"
                      value={this.state.countryResidence_text}
                      disableClearable
                      onChange={(event,value) => this.handleCustomDropDownClick_countryResidence(event,value)}
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option.descr_en).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option.descr_en}</Typography></React.Fragment>);}}
                      renderInput={params => <TextField {...params} error={this.state.countryResidence_hasError} label={this.NSInforString("SettingsProfilePersonal_plh08")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                    />
                  </FormControl>
                </GridItem>
              ) : ("") }
              {this.state.cityResidence_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    error={this.state.cityResidence_hasError}
                    className={classes.cityResidence}
                    id="cityResidence"
                    label={this.NSInforString("SettingsProfilePersonal_plh09")}
                    value={this.state.cityResidence}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "cityResidence"),
                      type: "text"
                    }}
                  />
                </GridItem>
              )}
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {this.state.homeAddress_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    error={this.state.homeAddress_hasError}
                    className={classes.homeAddress}
                    id="homeAddress"
                    label={this.NSInforString("SettingsProfilePersonal_plh10")}
                    value={this.state.homeAddress}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "homeAddress"),
                      type: "text"
                    }}
                  />
                </GridItem>
              )}
              {this.state.postalCode_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    error={this.state.postalCode_hasError}
                    className={classes.postalCode}
                    id="postalCode"
                    label={this.NSInforString("SettingsProfilePersonal_plh11")}
                    value={this.state.postalCode}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "postalCode"),
                      type: "text"
                    }}
                  />
                </GridItem>
              )}
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {this.state.profession_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.profession_hasError} className={classes.profession}>
                    <InputLabel id="profession_InputLabel">{this.NSInforString("SettingsProfilePersonal_plh12")}</InputLabel>
                    <Select
                      MenuProps={{ classes: { paper: classes.menuPaper } }}
                      displayEmpty
                      id="profession"
                      value={profession_text+""}
                      onChange={event => this.handleCustomDropDownClick_profession(event)}
                    >
                      {parserObject_getProfessions4Picker.map(function (akey) {
                        return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {this.state.positionLevel_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.positionLevel_hasError} className={classes.positionLevel}>
                    <InputLabel id="positionLevel_InputLabel">{this.NSInforString("SettingsProfilePersonal_plh12b")}</InputLabel>
                    <Select
                      displayEmpty
                      id="positionLevel"
                      value={positionLevel_text+""}
                      onChange={event => this.handleCustomDropDownClick_positionLevel(event)}
                    >
                      {parserObject_getPositionLevel4Picker.map(function (akey) {
                        return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}

            </GridContainer>
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <div>
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.labelHeader}>&nbsp;</div>
                  <div className={classes.textCenter}>
                    {/* <ReCAPTCHA
                      ref={ ref => this.recaptchaRef = ref }
                      locale={localStorage.getItem("lang")}
                      sitekey={api.captchKey}
                      onResolved={ this.btn_next_act } /> */}
                    <CustomButton
                      disabled={this.btn_next_act_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.btn_next_act}
                      type="submit">
                      {btn_next_text}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
              {/* -------------------------------------------------- */}
              {/* ----------[goBack Bottom]------------------------- */}
              {/* -------------------------------------------------- */}
              {api.backButtonAtBottom === true ? (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    <div className={classes.textCenter}>
                      <CustomButton
                        disabled={false}
                        className={classes.backButton}
                        color="rose"
                        onClick={this.goBack}>
                        {this.NSInforString("SettingsProfilePersonal_btn_prev")}
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              ) : ( "" ) }
            </div>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={3000} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
        {/* ------------------------------ */}
        {/* ----------[POPUP][CAMPAIGN]--- */}
        {/* ------------------------------ */}
        <div>
          <Dialog
            open={this.state.dialog101_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog101_handleClose}
            aria-labelledby="alert-dialog101-slide-title"
            aria-describedby="alert-dialog101-slide-description"
          >
            <DialogTitle id="alert-dialog101-slide-title">{api.popup_tile}</DialogTitle>
            {localStorage.getItem("lang")==="el" ? (
              <DialogContent><img src={WU_popup_campaign_el} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            ) : (
              <DialogContent><img src={WU_popup_campaign_en} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            )}
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog101_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_languages(event) {
    let methName = filename+"handleCustomDropDownClick_languages ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({ "preferredLanguage_text":eventTMP });
    if(localStorage.getItem("lang")==="el"){
      for(let i=0; i<this.state.parserObject_getLanguages4Picker_el.length; ++i){
        if(this.state.parserObject_getLanguages4Picker_el[i]===eventTMP){
          this.setState({
            "preferredLanguage_id"       : this.state.parserObject_getLanguages_el[i].lang_wu_id,
            "preferredLanguage_hasError" : false,
          });
          break;
        }
      }
    }
    else{
      for(let i=0; i<this.state.parserObject_getLanguages4Picker_en.length; ++i){
        if(this.state.parserObject_getLanguages4Picker_en[i]===eventTMP){
          this.setState({
            "preferredLanguage_id"       : this.state.parserObject_getLanguages_en[i].lang_wu_id,
            "preferredLanguage_hasError" : false,
          });
          break;
        }
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_birthCountryId(event,value) {
    let methName = filename+"handleCustomDropDownClick_birthCountryId ";
    let event_target_value = null;
    let eventTMP1          = null;
    let eventTMP2          = null;
    if(this.state.birthCountryId_AUTOCOMPLETE_MODE === "text"){
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    }
    else{
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value.descr_en;
    }
    if(api.print_logs){console.log(methName+"eventTMP1 = " + eventTMP1);}
    if(api.print_logs){console.log(methName+"eventTMP2 = " + eventTMP2);}
    if(api.print_logs){console.log(methName+"event     = " + event);}
    if(api.print_logs){console.log(methName+"value     = " + value);}

    this.setState({ "birthCountryId_text":eventTMP1 });
    for(let i=0; i<this.state.parserObject_getCountries4Picker.length; ++i){
      if(this.state.parserObject_getCountries4Picker[i]===eventTMP2){
        this.setState({
          "birthCountryId_id"       : this.state.parserObject_getCountries[i].ctry_wu_id ,
          "birthCountryId_hasError" : false,
        });
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_birthDateDay(event,value) {
    let methName = filename+"handleCustomDropDownClick_birthDateDay ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({ "birthDateDay_text":eventTMP, "birthDateDay_hasError" : false,"birthDateMonth_hasError" : false, "birthDateYear_hasError" : false  });

    this.checkBirthDate("day",eventTMP);
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_birthDateMonth(event,value) {
    let methName = filename+"handleCustomDropDownClick_birthDateMonth ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({ "birthDateMonth_text":eventTMP, "birthDateDay_hasError" : false,"birthDateMonth_hasError" : false, "birthDateYear_hasError" : false  });

    this.checkBirthDate("month",eventTMP);
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_birthDateYear(event,value) {
    let methName = filename+"handleCustomDropDownClick_birthDateYear ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({ "birthDateYear_text":eventTMP, "birthDateDay_hasError" : false,"birthDateMonth_hasError" : false, "birthDateYear_hasError" : false  });

    this.checkBirthDate("year",eventTMP);
  }
  //----------------------------------------------------------------------------------------------------
  checkBirthDate(lastSelected_key,lastSelected_val){
    let methName = filename+"checkBirthDate ";

    let dddd_TMP = "";
    let mmmm_TMP = "";
    let yyyy_TMP = "";
    if(lastSelected_key==="day"  ){ if(this.state.birthDateMonth_text === "" || this.state.birthDateYear_text  === ""){ return; } dddd_TMP = lastSelected_val; mmmm_TMP = this.state.birthDateMonth_text; yyyy_TMP = this.state.birthDateYear_text;  }
    if(lastSelected_key==="month"){ if(this.state.birthDateDay_text   === "" || this.state.birthDateYear_text  === ""){ return; } mmmm_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay_text;   yyyy_TMP = this.state.birthDateYear_text;  }
    if(lastSelected_key==="year" ){ if(this.state.birthDateDay_text   === "" || this.state.birthDateMonth_text === ""){ return; } yyyy_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay_text;   mmmm_TMP = this.state.birthDateMonth_text; }

    let birthdate = "";
    let yyyy = yyyy_TMP;
    let mmmm = mmmm_TMP.length===1 ? "0"+mmmm_TMP : mmmm_TMP;
    let dddd = dddd_TMP.length===1 ? "0"+dddd_TMP : dddd_TMP;
    let isValidDate = this.isValidDate(yyyy_TMP,mmmm_TMP,dddd_TMP); //console.log("isValidDate="+isValidDate);
    if(isValidDate===false){
      this.setState({"birthDateDay_hasError" : true,"birthDateMonth_hasError" : true, "birthDateYear_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("NotValidDate"));
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    birthdate = yyyy+"-"+mmmm+"-"+dddd;
    try{
      let d1 = new Date(); d1.setFullYear( d1.getFullYear() - 18 );
      let d2 = new Date(birthdate);
      if(d1.getTime() < d2.getTime()){
        this.setState({"birthDateDay_hasError" : true,"birthDateMonth_hasError" : true, "birthDateYear_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("birthdate_error_age"));
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_countryResidence(event,value) {
    let methName = filename+"handleCustomDropDownClick_countryResidence ";
    let event_target_value = null;
    let eventTMP1          = null;
    let eventTMP2          = null;
    if(this.state.countryResidence_AUTOCOMPLETE_MODE === "text"){
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    }
    else{
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value.descr_en;
    }
    if(api.print_logs){console.log(methName+"eventTMP1 = " + eventTMP1);}
    if(api.print_logs){console.log(methName+"eventTMP2 = " + eventTMP2);}
    if(api.print_logs){console.log(methName+"event     = " + event);}
    if(api.print_logs){console.log(methName+"value     = " + value);}

    this.setState({ "countryResidence_text":eventTMP1 });
    for(let i=0; i<this.state.parserObject_getCountries4Picker.length; ++i){
      if(this.state.parserObject_getCountries4Picker[i]===eventTMP2){
        this.setState({
          "countryResidence_id"       : this.state.parserObject_getCountries[i].ctry_wu_id,
          "countryResidence_hasError" : false,
          //
          "cityResidence"                                        : "",
          "cityResidence_hasError"                               : false,
          "homeAddress"                                          : "",
          "homeAddress_hasError"                                 : false,
          "postalCode"                                           : "",
          "postalCode_hasError"                                  : false,
          "phoneNumber"                                          : "",
          "phoneNumber_hasError"                                 : false,
        });
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_profession(event) {
    let methName = filename+"handleCustomDropDownClick_profession ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "profession_text"     : eventTMP,
      "profession_hasError" : false,
    });
    if(localStorage.getItem("lang")==="el"){
      for(let i=0; i<this.state.parserObject_getProfessions4Picker_el.length; ++i){
        if(this.state.parserObject_getProfessions4Picker_el[i]===eventTMP){
          this.setState({ "profession_id":this.state.parserObject_getProfessions_el[i].profession_wu_id });
          let profession_wu_id_TMP = this.state.parserObject_getProfessions_el[i].profession_wu_id;
          this.setState({ "positionLevel_isHidden":this.get_positionLevel_isHidden(profession_wu_id_TMP) });
          break;
        }
      }
    }
    else{
      for(let i=0; i<this.state.parserObject_getProfessions4Picker_en.length; ++i){
        if(this.state.parserObject_getProfessions4Picker_en[i]===eventTMP){
          this.setState({ "profession_id":this.state.parserObject_getProfessions_en[i].profession_wu_id });
          let profession_wu_id_TMP = this.state.parserObject_getProfessions_en[i].profession_wu_id;
          this.setState({ "positionLevel_isHidden":this.get_positionLevel_isHidden(profession_wu_id_TMP) });
          break;
        }
      }
    }
  }
  get_positionLevel_isHidden(profession_wu_id_TMP){
    if(profession_wu_id_TMP === "Civil/Government Employee"                  ||
       profession_wu_id_TMP === "Law Enforcement/Military Professional"      || //
       profession_wu_id_TMP === "Law Enforcement/Military"                   ||
       profession_wu_id_TMP === "Airline/Maritime Employee"                  ||
       profession_wu_id_TMP === "Art/Entertainment/Media Professional"       || //
       profession_wu_id_TMP === "Art/Entertainment/Media"                    ||
       profession_wu_id_TMP === "Teacher/Educator"                           ||
       profession_wu_id_TMP === "Hotel/Restaurant/Leisure Services Employee" || //
       profession_wu_id_TMP === "Hotel/Restaurant/Leisure"                   ||
       profession_wu_id_TMP === "IT and Tech Professional"                   ||
       profession_wu_id_TMP === "Medical and Health Care Professional"       || //
       profession_wu_id_TMP === "Medical/Health Care"                        ||
       profession_wu_id_TMP === "Cosmetic/Personal Care Services"            || //
       profession_wu_id_TMP === "Cosmetic/Personal Care"                     ||
       profession_wu_id_TMP === "Office Professional"                        ||
       profession_wu_id_TMP === "Retail Sales"                               ||
       profession_wu_id_TMP === "Sales/Insurance/Real Estate Professional"   || //
       profession_wu_id_TMP === "Sales/Insurance/Real Estate"                ||
       profession_wu_id_TMP === "Science/Research Professional"              ||
       profession_wu_id_TMP === "Skilled Trade/Specialist"                   ){
        return false;
    }
    else{
        return true;
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_positionLevel(event) {
    let methName = filename+"handleCustomDropDownClick_positionLevel ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "positionLevel_text"     : eventTMP,
      "positionLevel_hasError" : false,
    });
    if(localStorage.getItem("lang")==="el"){
      for(let i=0; i<this.state.parserObject_getPositionLevel4Picker_el.length; ++i){
        if(this.state.parserObject_getPositionLevel4Picker_el[i]===eventTMP){
          this.setState({ "positionLevel_id":this.state.parserObject_getPositionLevel[i].position_wu_id });
          break;
        }
      }
    }
    else{
      for(let i=0; i<this.state.parserObject_getPositionLevel4Picker_en.length; ++i){
        if(this.state.parserObject_getPositionLevel4Picker_en[i]===eventTMP){
          this.setState({ "positionLevel_id":this.state.parserObject_getPositionLevel[i].position_wu_id });
          break;
        }
      }
    }
  }
  translate_profession(lang,profession_id,profession_text){
    if(lang==="el"){
      for(let i=0; i<this.state.parserObject_getProfessions_el.length; ++i){ if(this.state.parserObject_getProfessions_el[i]["profession_wu_id"]===profession_id){ return this.state.parserObject_getProfessions_el[i]["descr_el"] } }
    }
    else{
      for(let i=0; i<this.state.parserObject_getProfessions_en.length; ++i){ if(this.state.parserObject_getProfessions_en[i]["profession_wu_id"]===profession_id){ return this.state.parserObject_getProfessions_en[i]["descr_en"] } }
    }
  }
  translate_positionLevel(lang,positionLevel_id,positionLevel_text){
    if(lang==="el"){
      for(let i=0; i<this.state.parserObject_getPositionLevel.length; ++i){ if(this.state.parserObject_getPositionLevel[i]["position_wu_id"]===positionLevel_id){ return this.state.parserObject_getPositionLevel[i]["descr_el"] } }
    }
    else{
      for(let i=0; i<this.state.parserObject_getPositionLevel.length; ++i){ if(this.state.parserObject_getPositionLevel[i]["position_wu_id"]===positionLevel_id){ return this.state.parserObject_getPositionLevel[i]["descr_en"] } }
    }
  }
  translate_language(lang,preferredLanguage_id, preferredLanguage_text){
    if(lang==="el"){
      for(let i=0; i<this.state.parserObject_getLanguages_el.length; ++i){ if(this.state.parserObject_getLanguages_el[i]["lang_wu_id"]===preferredLanguage_id){ return this.state.parserObject_getLanguages_el[i]["descr_el"] } }
    }
    else{
      for(let i=0; i<this.state.parserObject_getLanguages_en.length; ++i){ if(this.state.parserObject_getLanguages_en[i]["lang_wu_id"]===preferredLanguage_id){ return this.state.parserObject_getLanguages_en[i]["descr_en"] } }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_next_act_isDisabled(){
    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit_with_recaptcha(event) {
    let methName = filename+"handleSubmit_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.firstName.trim() === "")     { this.setState({"firstName_hasError" : true }); emptyFields = true; }
      if(this.state.lastName.trim() === "")      { this.setState({"lastName_hasError"  : true }); emptyFields = true; }
      if(this.state.email.trim() === "")         { this.setState({"email_hasError"     : true }); emptyFields = true; }

      if(this.state.preferredLanguage_id === "") { this.setState({"preferredLanguage_hasError" : true }); emptyFields = true; }
      if(this.state.birthCountryId_id === "")                                               { this.setState({"birthCountryId_hasError" : true }); emptyFields = true; }
      if(this.state.birthCountryId_id===this.NSInforString("SettingsProfilePersonal_plh05")){ this.setState({"birthCountryId_hasError" : true }); emptyFields = true; }
      if(this.state.birthCity.trim() === "")     { this.setState({"birthCity_hasError"         : true }); emptyFields = true; }
      if(this.state.birthDateDay_text   === ""){ this.setState({"birthDateDay_hasError"   : true }); emptyFields = true; }
      if(this.state.birthDateMonth_text === ""){ this.setState({"birthDateMonth_hasError" : true }); emptyFields = true; }
      if(this.state.birthDateYear_text  === ""){ this.setState({"birthDateYear_hasError"  : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.btn_next_act_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act(event) {
    let methName = filename+"btn_next_act ";
    if(api.print_logs){console.log(methName);}

    //let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //---------------------
    //newCustomer filtering---Settings---Button Action
    //---------------------
    let parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    let aTextDecision = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
    console.log(methName+"aTextDecision="+aTextDecision);
    if(aTextDecision === "FULL") { this.btn_next_act_FULL(event);  }
    if(aTextDecision === "LIGHT"){ this.btn_next_act_LIGHT(event); }
    if(aTextDecision === "BP")   { this.btn_next_act_BP(event);    }
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act_FULL(event) {
    let methName = filename+"btn_next_act_FULL ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.firstName.trim() === "")                                                { this.setState({"firstName_hasError"         : true }); emptyFields = true; }
      if(this.state.lastName.trim() === "")                                                 { this.setState({"lastName_hasError"          : true }); emptyFields = true; }
      if(this.state.email.trim() === "")                                                    { this.setState({"email_hasError"             : true }); emptyFields = true; }
      if(this.state.preferredLanguage_id === "")                                            { this.setState({"preferredLanguage_hasError" : true }); emptyFields = true; }
      if(this.state.birthCountryId_id === "")                                               { this.setState({"birthCountryId_hasError"    : true }); emptyFields = true; }
      if(this.state.birthCountryId_id===this.NSInforString("SettingsProfilePersonal_plh05")){ this.setState({"birthCountryId_hasError"    : true }); emptyFields = true; }
      if(this.state.birthCity.trim() === "")                                                { this.setState({"birthCity_hasError"         : true }); emptyFields = true; }
      if(this.state.birthDateDay_text   === "")                                             { this.setState({"birthDateDay_hasError"      : true }); emptyFields = true; }
      if(this.state.birthDateMonth_text === "")                                             { this.setState({"birthDateMonth_hasError"    : true }); emptyFields = true; }
      if(this.state.birthDateYear_text  === "")                                             { this.setState({"birthDateYear_hasError"     : true }); emptyFields = true; }
      if(this.state.countryResidence_text=== "")                                            { this.setState({"countryResidence_hasError"  : true }); emptyFields = true; } //countryResidence_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.cityResidence.trim() === "")                                            { this.setState({"cityResidence_hasError"     : true }); emptyFields = true; }
      if(this.state.homeAddress.trim() === "")                                              { this.setState({"homeAddress_hasError"       : true }); emptyFields = true; }
      if(this.state.postalCode.trim() === "")                                               { this.setState({"postalCode_hasError"        : true }); emptyFields = true; }
      if(emptyFields===true){this.stopLockers();if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //------------------
    //validate firstName---TextField
    //------------------
  //let firstName      = this.state.firstName.trim();
    let textField1text = this.state.firstName.trim();
    if(textField1text === ""){
      this.setState({"firstName_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh01")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    if(wu_Utilities.offline_validate_latinCharacters(textField1text.replace(/ /g,""))===false){
      this.setState({"firstName_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh01")+"\" "+this.NSInforString("with_latin"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    if(textField1text.length < 2 || textField1text.length > 36){
      this.setState({"firstName_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.firstName.size"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //-----------------
    //validate lastName---TextField
    //-----------------
  //let lastName       = this.state.lastName.trim();
    let textField2text = this.state.lastName.trim();
    if(textField2text === ""){
      this.setState({"lastName_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh02")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    if(wu_Utilities.offline_validate_latinCharacters(textField2text.replace(/ /g,""))===false){
      this.setState({"lastName_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh02")+"\" "+this.NSInforString("with_latin"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    if(textField2text.length < 2 || textField2text.length > 36){
      this.setState({"lastName_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.lastName.size"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //---------------------------
    //validate firstName+lastName---TextField
    //---------------------------
    if(textField1text.length + textField2text.length > 39){
      this.setState({"firstName_hasError" : true });
      this.setState({"lastName_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.firstlastName.size"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //--------------
    //validate email---TextField
    //--------------
    let emailBase64    = new Buffer(this.state.email.trim()).toString('base64');
    let email          = this.state.email.trim();
    let textField3text = this.state.email.trim();
    localStorage.setItem("HTTP_user", email);
    if(textField3text === ""){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh03")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    if(this.verifyGenericItem("email",textField3text)===false){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //-----------------
    //validate Language---Picker
    //-----------------
    let language = this.state.preferredLanguage_id;
    if(language === ""){
      this.setState({"preferredLanguage_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfilePersonal_plh04"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //-----------------------
    //validate birthCountryId---Picker
    //-----------------------
    let birthCountryId = this.state.birthCountryId_id;
    if(birthCountryId === ""){
      this.setState({"birthCountryId_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfilePersonal_plh05"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    if(this.state.birthCountryId_id===this.NSInforString("SettingsProfilePersonal_plh05")){
      this.setState({"birthCountryId_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfilePersonal_plh05"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //------------------
    //validate birthCity---TextField
    //------------------
    let birthCity = this.state.birthCity.trim();
    if(birthCity === ""){
      this.setState({"birthCity_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh06")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    let birthCityTMP = this.state.birthCity.trim();
    birthCityTMP = birthCityTMP.replace(/-/g,"");
    birthCityTMP = birthCityTMP.replace(/,/g,"");
    birthCityTMP = birthCityTMP.replace(/\./g,"");
    birthCityTMP = birthCityTMP.replace(/ /g,"");
    if(wu_Utilities.offline_validate_latinAlphaNumeric(birthCityTMP)===false){
      this.setState({"birthCity_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh06")+"\" "+this.NSInforString("with_latin"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //------------------
    //validate birthDate---Picker
    //------------------
    // let birthDate = this.state.birthDate;
    // //this.dialog_handleOpen("birthDate="+birthDate);
    // //mainDelegate.birthYear = [picker1_arr_years   objectAtIndex:(int)[picker1 selectedRowInComponent:k_BIRTH_YEAR_Component]];
    // if(birthDate === "" || birthDate === birthDate_dv){ //"0001-01-01"
    //   this.setState({"birthDate_hasError" : true });
    //   this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfilePersonal_plh07"));
    //   if(shouldResetCaptcha){this.recaptchaRef.reset();}
    //   this.stopLockers(); return;
    // }
    // if(birthDate === this.NSInforString("SettingsProfilePersonal_plh07")){
    //   this.setState({"birthDate_hasError" : true });
    //   this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfilePersonal_plh07"));
    //   if(shouldResetCaptcha){this.recaptchaRef.reset();}
    //   this.stopLockers(); return;
    // }
    // let year = birthDate.length>=4 ? birthDate.substring(0, 4) : "";
    // localStorage.setItem("birthYear",year);
    //------------------
    //validate birthDate---Multi Picker
    //------------------
    let yyyy = this.state.birthDateYear_text;
    let mmmm = this.state.birthDateMonth_text.length===1 ? "0"+this.state.birthDateMonth_text : this.state.birthDateMonth_text;
    let dddd = this.state.birthDateDay_text.length===1   ? "0"+this.state.birthDateDay_text   : this.state.birthDateDay_text;
    let isValidDate = this.isValidDate(this.state.birthDateYear_text,this.state.birthDateMonth_text,this.state.birthDateDay_text); //console.log("isValidDate="+isValidDate);
    if(isValidDate===false){
      this.setState({"birthDateDay_hasError" : true,"birthDateMonth_hasError" : true, "birthDateYear_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+this.NSInforString("SettingsProfilePersonal_plh07"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    let birthDate = yyyy+"-"+mmmm+"-"+dddd;
    let year = birthDate.length>=4 ? birthDate.substring(0, 4) : "";
    localStorage.setItem("birthYear",year);
    //console.log("this.state.birthDate="+this.state.birthDate);
    //console.log("birthDate           ="+birthDate);
    //-------------------------
    //validate countryResidence---Picker(validate:id,label)
    //-------------------------
    let countryResidence = this.state.countryResidence_id;
    if(countryResidence === ""){
        this.setState({"countryResidence_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfilePersonal_plh08"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers(); return;
    }
    //----------------------
    //validate cityResidence---TextField
    //----------------------
    let cityResidence          = this.state.cityResidence.trim();
    let cityResidence_VALIDATE = true;
    if(cityResidence_VALIDATE===true){
      let textField1text = this.state.cityResidence.trim();
      if(textField1text === ""){
          this.setState({"cityResidence_hasError" : true });
          this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh09")+"\"");
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopLockers(); return;
      }
      let textField1textTMP = this.state.cityResidence.trim();
      textField1textTMP = textField1textTMP.replace(/-/g,"");
      textField1textTMP = textField1textTMP.replace(/,/g,"");
      textField1textTMP = textField1textTMP.replace(/\./g,"");
      textField1textTMP = textField1textTMP.replace(/ /g,"");
      if(wu_Utilities.offline_validate_latinAlphaNumeric(textField1textTMP)===false){
          this.setState({"cityResidence_hasError" : true });
          this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh09")+"\" "+this.NSInforString("with_latin"));
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopLockers(); return;
      }
      if(textField1text.length > 50){
          this.setState({"cityResidence_hasError" : true });
          this.dialog_handleOpen(this.NSInforString("common.cityResidence.size"));
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopLockers(); return;
      }
    }
    //---------------------
    //validate Home Address---TextField
    //---------------------
    let homeAddress          = this.state.homeAddress.trim();
    let homeAddress_VALIDATE = true;
    if(homeAddress_VALIDATE===true){
      let textField2text = this.state.homeAddress.trim();
      if(textField2text === ""){
          this.setState({"homeAddress_hasError" : true });
          this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh10")+"\"");
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopLockers(); return;
      }
      let textField2textTMP = this.state.homeAddress.trim();
      textField2textTMP = textField2textTMP.replace(/-/g,"");
      textField2textTMP = textField2textTMP.replace(/,/g,"");
      textField2textTMP = textField2textTMP.replace(/\./g,"");
      textField2textTMP = textField2textTMP.replace(/ /g,"");
      if(wu_Utilities.offline_validate_latinAlphaNumeric(textField2textTMP)===false){ //accept keno,-
          this.setState({"homeAddress_hasError" : true });
          this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh10")+"\" "+this.NSInforString("with_latin"));
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopLockers(); return;
      }
      if(textField2text.length > 50){
          this.setState({"homeAddress_hasError" : true });
          this.dialog_handleOpen(this.NSInforString("common.homeAddress.size"));
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopLockers(); return;
      }
    }
    //--------------------
    //validate Postal Code---TextField
    //--------------------
    let postalCode          = this.state.postalCode.trim();
    let postalCode_VALIDATE = true;
    if(postalCode_VALIDATE===true){
      let textField3text = this.state.postalCode.trim();
      if(textField3text === ""){
          this.setState({"postalCode_hasError" : true });
          this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh11")+"\"");
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopLockers(); return;
      }
      if(wu_Utilities.offline_validate_latinAlphaNumeric(textField3text.replace(/ /g,""))===false){
          this.setState({"postalCode_hasError" : true });
          this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh11")+"\" "+this.NSInforString("with_latin"));
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopLockers(); return;
      }
    }
    //-------------------
    //validate profession---Picker
    //-------------------
    let profession = this.state.profession_id;
    if(profession  === ""){
      this.setState({"profession_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfilePersonal_plh12"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //----------------------
    //validate positionLevel---Picker
    //----------------------
    let positionLevel = "";
    if(this.state.positionLevel_isHidden === false){
        positionLevel = this.state.positionLevel_id;
        if(positionLevel  === ""){
          this.setState({"positionLevel_hasError" : true });
          this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfilePersonal_plh12b"));
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopLockers(); return;
        }
    }


    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //++++++++
    //Continue
    //++++++++
    //event.preventDefault();
    //--------------
    //update profile
    //--------------
    let parserObject_updateCustomerData_req = {};
    parserObject_updateCustomerData_req["step"]                = "updatePersonalDetails";
    parserObject_updateCustomerData_req["email"]               = emailBase64;      //xxx sos
    parserObject_updateCustomerData_req["preferredLanguage"]   = language;         //None
    parserObject_updateCustomerData_req["homeAddress"]         = homeAddress;      //Swrou 11
    parserObject_updateCustomerData_req["postalCode"]          = postalCode;       //
    parserObject_updateCustomerData_req["countryResidence"]    = countryResidence; //
    parserObject_updateCustomerData_req["cityResidence"]       = cityResidence;    //
    parserObject_updateCustomerData_req["profession"]          = profession;       //UNEMPLOYED
    parserObject_updateCustomerData_req["Position_Level_id"]   = positionLevel;    //

    localStorage.setItem("parserObject_updateCustomerData_req", JSON.stringify(parserObject_updateCustomerData_req));

    this.startSpinners();
    setTimeout(function() { //Start the timer
      //------------------
      //updateCustomerData
      //------------------
      wu_ProfileService
      .wu_updateCustomerData(parserObject_updateCustomerData_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="SettingsProfilePersonal"){if(api.print_logs){console.log(methName+"5A11");}this.stopLockers(); return;}//5A11
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();this.stopSpinners();

        history.goBack();
      })
      .catch(err => {
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act_LIGHT(event) {
    let methName = filename+"btn_next_act_LIGHT ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.email.trim() === "")                                                    { this.setState({"email_hasError"             : true }); emptyFields = true; }
      if(this.state.preferredLanguage_id === "")                                            { this.setState({"preferredLanguage_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //--------------
    //validate email---TextField
    //--------------
  //let emailBase64    = new Buffer(this.state.email.trim()).toString('base64');
    let email          = this.state.email.trim();
    let textField3text = this.state.email.trim();
    localStorage.setItem("HTTP_user", email);
    if(textField3text === ""){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh03")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    if(this.verifyGenericItem("email",textField3text)===false){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //-----------------
    //validate Language---Picker
    //-----------------
    let language = this.state.preferredLanguage_id;
    if(language === ""){
      this.setState({"preferredLanguage_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfilePersonal_plh04"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }


    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    //event.preventDefault();

    //try { localStorage.setItem("idBoxFlow","WorldBridgeNoVideo"); } catch(err){;}
    try { localStorage.setItem("newRegistrationFlow","newCustomer"); } catch(err){;}
    //+++++++++++++++
    //Goto Controller
    //+++++++++++++++
    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
    history.push(wu_Utilities.getNavigationURLs("RegisterLight2"));
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act_BP(event) {
    let methName = filename+"btn_next_act_BP ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.email.trim() === "")                                                    { this.setState({"email_hasError"             : true }); emptyFields = true; }
      if(this.state.preferredLanguage_id === "")                                            { this.setState({"preferredLanguage_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //--------------
    //validate email---TextField
    //--------------
  //let emailBase64    = new Buffer(this.state.email.trim()).toString('base64');
    let email          = this.state.email.trim();
    let textField3text = this.state.email.trim();
    localStorage.setItem("HTTP_user", email);
    if(textField3text === ""){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfilePersonal_plh03")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    if(this.verifyGenericItem("email",textField3text)===false){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //-----------------
    //validate Language---Picker
    //-----------------
    let language = this.state.preferredLanguage_id;
    if(language === ""){
      this.setState({"preferredLanguage_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfilePersonal_plh04"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }


    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    //event.preventDefault();

    //try { localStorage.setItem("idBoxFlow","WorldBridgeNoVideo"); } catch(err){;}
    try { localStorage.setItem("newRegistrationFlow","upgradeAccount"); } catch(err){;}
    //+++++++++++++++
    //Goto Controller
    //+++++++++++++++
    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
    history.push(wu_Utilities.getNavigationURLs("RegisterLight2"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="firstName"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "firstName"          : eventTMP,
        "firstName_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"firstName_hasError":true}); return; }
      if(eventTMP.length > 36){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstName.size")); this.setState({"firstName_hasError":true}); return; }
      if(eventTMP.trim().length + this.state.lastName.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstlastName.size")); this.setState({"firstName_hasError":true, "lastName_hasError":true}); return; }
      else                                                               { this.setState({"firstName_hasError":false, "lastName_hasError":false}); }
    }
    else if(stateVar==="lastName"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "lastName"          : eventTMP,
        "lastName_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"lastName_hasError":true}); return; }
      if(eventTMP.length > 36){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstName.size")); this.setState({"lastName_hasError":true}); return; }
      if(this.state.firstName.trim().length + eventTMP.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstlastName.size")); this.setState({"firstName_hasError":true, "lastName_hasError":true}); return; }
      else                                                                { this.setState({"firstName_hasError":false, "lastName_hasError":false}); }
    }
    else if(stateVar==="email"){
      //eventTMP = eventTMP.toUpperCase();
      this.setState({
        "email"          : eventTMP,
        "email_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      //eventTMP = eventTMP.replace(/ /g,"");
      //eventTMP = eventTMP.replace(/_/g,"");
      //eventTMP = eventTMP.replace(/@/g,"");
      //eventTMP = eventTMP.replace(/\./g,"");
      //if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP)===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); return; }
    }
    else if(stateVar==="birthCity"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "birthCity"          : eventTMP,
        "birthCity_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      //accept [keno][-][,][.]
      eventTMP = eventTMP.replace(/-/g,"");
      eventTMP = eventTMP.replace(/,/g,"");
      eventTMP = eventTMP.replace(/\./g,"");
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"birthCity_hasError":true}); return; }
    }
    if(stateVar==="cityResidence"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "cityResidence"          : eventTMP,
        "cityResidence_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      //accept [keno][-][,][.]
      eventTMP = eventTMP.replace(/-/g,"");
      eventTMP = eventTMP.replace(/,/g,"");
      eventTMP = eventTMP.replace(/\./g,"");
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"cityResidence_hasError":true}); return; }
    }
    else if(stateVar==="homeAddress"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "homeAddress"          : eventTMP,
        "homeAddress_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      //accept [keno][-][,][.]
      eventTMP = eventTMP.replace(/-/g,"");
      eventTMP = eventTMP.replace(/,/g,"");
      eventTMP = eventTMP.replace(/\./g,"");
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"homeAddress_hasError":true}); return; }
    }
    else if(stateVar==="postalCode"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "postalCode"          : eventTMP,
        "postalCode_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"postalCode_hasError":true}); return; }
    }
    else{
      //console.log(stateVar+"-"+eventTMP);
      if(eventTMP===""){eventTMP=birthDate_dv;}
      this.setState({ [stateVar] : eventTMP });
      if(eventTMP!==""){this.setState({"birthDate_hasError" : true }); }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email")                            { return wu_Utilities.wu_verifyEmail(val); }
    if(key==="firstName")                        { return wu_Utilities.offline_validate_firstName(val); }
    if(key==="lastName")                         { return wu_Utilities.offline_validate_lastName(val);  }
    if(key==="birthCity")                        { return wu_Utilities.offline_validate_birthCity(val);  }
    if(key==="homeAddress")                      { val = val.replace(/ /i, ""); return wu_Utilities.offline_validate_homeAddress(val);  }
    if(key==="cityResidence")                    { val = val.replace(/ /i, ""); return wu_Utilities.offline_validate_cityResidence(val);  }
    if(key==="phone_landline")                   { return wu_Utilities.offline_validate_phone_landline(val);  }
    if(key==="phone_mobile")                     { return wu_Utilities.offline_validate_phone_mobile(val);  }

    return false;
  }
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  getCountryImageSrc(country) {
    if(country.toUpperCase()==="DE"){return "assets/img/wu/testImg2.png";}
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  //https://stackoverflow.com/questions/21188420/javascript-date-validation-not-validation-february-31
  isValidDate(year, month, day) {
    let methName = filename+"isValidDate ";
    if(api.print_logs){console.log(methName);}

    try{
      let year_int  = parseInt(year);
      let month_int = parseInt(month)-1;
      let day_int   = parseInt(day);
      var d = new Date(year_int, month_int, day_int);
      //console.log(methName+"d.getFullYear()="+d.getFullYear()+" year_int="+year_int);
      //console.log(methName+"d.getMonth()   ="+d.getMonth()+"    month_int="+month_int);
      //console.log(methName+"d.getDate()    ="+d.getDate()+"     day_int="+day_int);
      if (d.getFullYear() === year_int && d.getMonth() === month_int && d.getDate() === day_int) {
          return true;
      }
    }catch(err){
      console.log(methName+"err="+err)
      return false;
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[CAMPAIGN]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog101_handleOpen(dialog_msg){
    this.setState({ "dialog101_isOpen" : true });
    this.setState({ "dialog101_msg"    : dialog_msg });
  }
  dialog101_handleClose(){
    this.setState({ "dialog101_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"RG1"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( SettingsProfilePersonal_continue_locked===true ){ return true;  }
    else                                                { return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    SettingsProfilePersonal_continue_locked = true;
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    SettingsProfilePersonal_continue_locked = false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Specific------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  buttons_show_hide() {
    let methName = filename+"buttons_show_hide ";
    if(api.print_logs){console.log(methName);}

    //let parserObject_validatecustomer = {};
    //try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}

    if(api.print_logs){console.log(methName+"this.state.idIssuingCountry_id = "+this.state.idIssuingCountry_id);}
    if(api.print_logs){console.log(methName+"this.state.idType_text         = "+this.state.idType_text);}

    let idIssuingCountry_disabled = false;
    let idType_disabled           = false;
    let idNumber_disabled         = false;
    let btn_next_isHidden         = false;
    this.setState({
      idIssuingCountry_disabled : idIssuingCountry_disabled,
      idType_disabled           : idType_disabled,
      idNumber_disabled         : idNumber_disabled,

      btn_next_isHidden         : btn_next_isHidden,
    });
  }
  //----------------------------------------------------------------------------------------------------
}
SettingsProfilePersonal.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(SettingsProfilePersonalStyle)(SettingsProfilePersonal)
);
